/**
 * @author mi
 * @date 2019/12/11
 * @project kaoshizhongxin-pc
 */
function getWithCancel (promise, token, cancel) {
  return Promise.race([promise, new Promise((resolve, reject) => {
    token.cancel = function () {
      reject(new Error('cancel'))
      cancel && cancel()
    }
  })]).then(res => {
    console.log(res)
  }).catch((err) => {
    console.log(err)
  })
}

export function makeCancelable (promise, cancel) {
  var token = {}
  getWithCancel(promise, token, cancel)
  return token
}
